"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var group_1 = require("./group");
exports.GroupService = group_1.GroupService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/group/services/index.js
// module id = 481
// module chunks = 0